import { ProspectTaskDto } from "@crowdcoursing/api/openapi";
import { TaskType } from "~hooks/useTaskDashboard";

// Combined task type for the carousel
export interface CarouselTaskItem extends ProspectTaskDto {
  type: TaskType;
  // Common properties across all task types
  entityId?: string;       // ID of the related entity (prospect/room/event)
  entityName?: string;     // Name of the related entity
  entityImage?: string;    // Image URL of the related entity
  entityType?: string;     // Type of entity (individual, organization, etc.)
  category?: string;       // Task category (meeting, follow-up, document, etc.)
  tags?: string[];         // Tags for filtering and organization
  isRecurring?: boolean;   // Whether the task repeats
  relatedUsers?: Array<{   // Users related to this task
    id: string;
    name: string;
    role: string;
  }>;
}

// Map sales tasks to the common format
export const mapSalesTask = (task: ProspectTaskDto): CarouselTaskItem => {
  // Extract tags from description
  const tags: string[] = [];
  if (task.description) {
    // Look for hashtags in description
    const hashtagRegex = /#(\w+)/g;
    let match;
    while ((match = hashtagRegex.exec(task.description)) !== null) {
      tags.push(match[1]);
    }
  }

  // Progress calculation removed

  return {
    ...task,
    type: "sales" as TaskType,
    entityId: task.prospectId,
    entityName: task.prospectName || "Unknown Prospect",
    entityType: "Prospect",
    tags,
    isRecurring: false, // Default for now
    relatedUsers: task.assignedToFirstName ? [
      {
        id: task.assignedToUserId || "",
        name: `${task.assignedToFirstName} ${task.assignedToLastName || ""}`.trim(),
        role: "Assigned"
      }
    ] : [],
  };
};

// Map room tasks to the common format (placeholder)
export const mapRoomTask = (task: any): CarouselTaskItem => {
  return {
    ...task,
    type: "room" as TaskType,
    entityId: task.roomId,
    entityName: task.roomName || "Unknown Room",
    entityType: "Room",
    category: "Room Task",
    tags: [],
  };
};

// Map event tasks to the common format (placeholder)
export const mapEventTask = (task: any): CarouselTaskItem => {
  return {
    ...task,
    type: "event" as TaskType,
    entityId: task.eventId,
    entityName: task.eventName || "Unknown Event",
    entityType: "Event",
    category: "Event Task",
    tags: [],
  };
};

// Combine tasks from different sources into a unified format
export const combineTasks = (
  salesTasks: ProspectTaskDto[] = [],
  roomTasks: any[] = [],
  eventTasks: any[] = []
): CarouselTaskItem[] => {
  return [
    ...salesTasks.map(mapSalesTask),
    ...roomTasks.map(mapRoomTask),
    ...eventTasks.map(mapEventTask),
  ];
};
